import { render, staticRenderFns } from "./ImageCarouselMessage.vue?vue&type=template&id=3b656981&scoped=true&"
import script from "./ImageCarouselMessage.vue?vue&type=script&lang=js&"
export * from "./ImageCarouselMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImageCarouselMessage.vue?vue&type=style&index=0&id=3b656981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b656981",
  null
  
)

export default component.exports